import type { LucideIcon } from 'lucide-react';
import {
  Home,
  CalendarDays,
  Package,
  CreditCard,
  Bot,
  FileText,
  Globe,
  Building2,
  Users,
  Settings,
  Layers,
  RotateCcw,
  Activity,
} from 'lucide-react';

export type PromoNavItem = {
  key: string;
  label: string;
  path: string;
  icon: LucideIcon;
};

export const TEACHER_PROMO_NAV: PromoNavItem[] = [
  { key: 'overview', label: 'Overview', path: '/', icon: Home },
  { key: 'students', label: 'Students', path: '/students', icon: Users },
  { key: 'bookings', label: 'Bookings', path: '/bookings', icon: CalendarDays },
  { key: 'packages', label: 'Packages', path: '/packages', icon: Package },
  { key: 'payments', label: 'Payments', path: '/payments', icon: CreditCard },
  { key: 'ai_practice', label: 'AI Practice', path: '/ai-exercises', icon: Bot },
  { key: 'blog', label: 'Blog', path: '/blogs', icon: FileText },
  { key: 'website', label: 'Website', path: '/portfolio', icon: Globe },
];

export const STUDENT_PROMO_NAV: PromoNavItem[] = [
  { key: 'overview', label: 'Overview', path: '/', icon: Home },
  { key: 'bookings', label: 'Bookings', path: '/bookings', icon: CalendarDays },
  { key: 'billing', label: 'Billing', path: '/billing/subscriptions', icon: CreditCard },
  { key: 'ai_practice', label: 'AI Practice', path: '/ai-exercises', icon: Bot },
];

export const SUPERADMIN_PROMO_NAV: PromoNavItem[] = [
  { key: 'tenants', label: 'Tenants', path: '/tenants', icon: Building2 },
  { key: 'users', label: 'Users', path: '/tenants/users', icon: Users },
  { key: 'features', label: 'Features', path: '/tenants/features', icon: Settings },
  { key: 'payments', label: 'Payments', path: '/tenants/payments', icon: CreditCard },
  { key: 'saas_plans', label: 'SaaS plans', path: '/tenants/saas-plans', icon: Layers },
  { key: 'refunds', label: 'Refunds', path: '/tenants/refunds', icon: RotateCcw },
  {
    key: 'billing_activity',
    label: 'Billing stream',
    path: '/tenants/billing-activity',
    icon: Activity,
  },
];

export function matchPromoNavPath(pathname: string, itemPath: string): boolean {
  if (itemPath === '/') return pathname === '/';
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
}
